var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.25L15.75 2.75M15.75 2.75H11.25M15.75 2.75L9.75 8.75M7.5 4.25H5.85C4.58988 4.25 3.95982 4.25 3.47852 4.49524C3.05516 4.71095 2.71095 5.05516 2.49524 5.47852C2.25 5.95982 2.25 6.58988 2.25 7.85V12.65C2.25 13.9101 2.25 14.5402 2.49524 15.0215C2.71095 15.4448 3.05516 15.789 3.47852 16.0048C3.95982 16.25 4.58988 16.25 5.85 16.25H10.65C11.9101 16.25 12.5402 16.25 13.0215 16.0048C13.4448 15.789 13.789 15.4448 14.0048 15.0215C14.25 14.5402 14.25 13.9101 14.25 12.65V11",
    stroke: "#2E5BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkButton);
export default __webpack_public_path__ + "static/media/LinkButton.37b55d67c03e0439dfe53cf339f1d3ad.svg";
export { ForwardRef as ReactComponent };